import React from 'react';
import './Loader.css';

const Loader = ({ message = 'Processing payment...' }) => {
  return (
    <div className='loader-container'>
      <div className='loader-content'>
        <div className='loader'></div>
        <div className='loader-message'>{message}</div>
      </div>
    </div>
  );
};

export default Loader;
